export default class AnalyticsData {
  constructor(_hashAnalytics) {
    this.hashAnalytics = _hashAnalytics;
  }
  set hashAnalytics(str){
    this._hashAnalytics = str;
  }
  get hashAnalytics(){
    return this.hashAnalytics;
  }
}